import client from './client'
import type { AdminOrganisation, AdminOrganisationDetail } from '@/types/organisations'
import type { PaginatedResponse } from '@/types/shared'

export interface ListOrganisationsParams {
  search?: string
  page?: number
  per_page?: number
}

export async function listOrganisations(
  params: ListOrganisationsParams = {},
): Promise<PaginatedResponse<AdminOrganisation>> {
  const { data } = await client.get<PaginatedResponse<AdminOrganisation>>('/admin/organisations', { params })
  return data
}

export async function fetchOrganisation(id: number): Promise<AdminOrganisationDetail> {
  const { data } = await client.get<{ data: AdminOrganisationDetail }>(`/admin/organisations/${id}`)
  return data.data
}
